module.exports = __webpack_public_path__ + "static/media/marion-bourgine.8e04184a.png";